export default function () {
  return {
    config: {
      APP: {
        RELEASE_TAG: process.env.RELEASE_TAG,
      },
      CACHCONTROLGUID: '',
      IDIN: {
        REDIRECT_URI: '',
        BASE_URL: '',
        CLIENT_ID: '',
      },
      API: {
        BASE_URL: '',
        CONTENT_BASE_URL: '',
      },
      DEFAULT_GTM_CODE: '',
      DEFAULT_GA_CODE: '',
      COLLECTIVITY_INFORMATION: [],
      ENFORCE_HTTPS: false,
      ENVIRONMENT: '',
      FRONT_END_URL: '',
      APPLICATION_INSIGHTS: {
        INSTRUMENTATION_KEY: '',
        CONNECTION_STRING: '',
      },
    },
  };
}
